<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Form Inputs</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-input
                  label="Email"
                  class="w-full"
                  v-model="email"
                  placeholder="Email"
                />
              </vs-col>
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-input
                  label="Password"
                  type="password"
                  class="w-full"
                  v-model="password"
                  placeholder="Password"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input
                  label="Address"
                  class="w-full"
                  v-model="address"
                  placeholder="1234 Main St"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input
                  label="Address 2"
                  class="w-full"
                  v-model="address2"
                  placeholder="Appartment, Studio"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="5" vs-sm="6" vs-xs="12">
                <vs-input
                  label="City"
                  class="w-full"
                  v-model="city"
                  placeholder="City"
                />
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                <vs-select v-model="state" class="w-full" label="State">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in states"
                    class="w-full"
                  />
                </vs-select>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
                <vs-input
                  label="Zip"
                  v-model="zip"
                  class="w-full"
                  placeholder="Zip"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <label for="" class="vs-input--label">Date</label>
                <datepicker
                  name="start-date"
                  v-model="date"
                  label="Date"
                  input-class="vs-inputx vs-input--input normal"
                ></datepicker>
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="left">
                <vs-checkbox
                  class="content-start justify-start"
                  v-model="option"
                >
                  Remember Me
                </vs-checkbox>
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="left">
                <vs-button> Submit </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
require("vue-simple-calendar/static/css/default.css");
require("vue-simple-calendar/static/css/holidays-us.css");
export default {
  components: { Datepicker },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      email: "",
      password: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      date: "",
      option: true,
      states: [
        { text: "New York", value: "new-york" },
        { text: "New York", value: "new-york" },
        { text: "New York", value: "new-york" },
      ],
    };
  },
};
</script>